import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

import HeroImage from "@assets/images/onboarding/gradient-light.svg?url";

export const AuthLayout = () => {
	return (
		<Box
			id="portal-auth"
			sx={{
				width: "100vw",
				height: "100vh",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column",
			}}
		>
			<Box
				alt="Background image"
				component="img"
				src={HeroImage}
				sx={{
					width: "100%",
					height: "100%",
					position: "fixed",
					inset: 0,
					zIndex: -1,
					objectFit: "cover",
				}}
			/>

			<Outlet />
		</Box>
	);
};
